import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-card-customer-details',
  templateUrl: './card-customer-details.component.html',
  styleUrls: ['./card-customer-details.component.scss']
})
export class CardCustomerDetailsComponent implements OnInit {
  title: any = null;
  input_type_list = ['Booth Code', 'Customer Code', 'Customer Type'];
  selected_input_type: any = null;
  business_code: any = null;
  customer_code: any = null;
  customer_type_list: any;
  selected_customer_types: any = null;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  data_dict: any;
  all_business_list: any = null;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getCustomerType().subscribe((customer_type_list: []) => {
      console.log(customer_type_list);
      this.customer_type_list = customer_type_list;
    }, (error) => {
      console.log(error);
    });
    this.httpService.getAllbusiness().subscribe((all_business_list: []) => {
      console.log(all_business_list);
      this.all_business_list = all_business_list;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    this.document_file = null;
    if(this.selected_input_type == 'Booth Code'){
      this.data_dict = {
        'input_type': this.selected_input_type,
        'business_code': this.business_code
      };
    }
    else if(this.selected_input_type == 'Customer Code'){
      this.data_dict = {
        'input_type': this.selected_input_type,
        'customer_code': this.customer_code
      };
    }
    else{
      this.data_dict = {
        'input_type': this.selected_input_type,
        'selected_customer_type': this.selected_customer_types,
      };
    }
    console.log(this.data_dict);
    this.is_document_available = false;
    this.httpService.serveCustomerDetails(this.data_dict).subscribe((data) => {
      console.log(data);
      this.is_document_available = true;
      this.business_code = null
      this.customer_code = null
      if (data['data_availble']) {
        this.document_file = data;
      } else {
        alert(data['alert']);
        return false;
      }
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadOption() {
    this.document_file = null;
  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
